/* assets/b2o-lp01.js */
(() => {
    const SELECTOR_ROOT = ".b2o-lp01-webflow-mount"; // tu section class

    // ---------- Helpers ----------
    const qs = (root, sel) => (root || document).querySelector(sel);
    const qsa = (root, sel) => Array.from((root || document).querySelectorAll(sel));

    const once = (el, key) => {
        if (!el) return false;
        const attr = `data-${key}-init`;
        if (el.hasAttribute(attr)) return false;
        el.setAttribute(attr, "1");
        return true;
    };

    // ---------- Swiper ----------
    function initSwipers(root) {
        if (typeof window.Swiper === "undefined") return;

        // Generic init for components like:
        // <div swiper="sw07"> ... <div swiper="slider" class="swiper"> ...
        qsa(root, '[swiper]').forEach(() => {
            // no-op, just ensures root traversal happens
        });

        // SW07 (before/after reviews carousel)
        qsa(root, '[swiper="sw07"]').forEach((sliderComponent) => {
            if (!once(sliderComponent, "swiper-sw07")) return;

            const sliderEl = qs(sliderComponent, '[swiper="slider"]');
            const buttonNextEl = qs(sliderComponent, '[swiper="next-button"]');
            const buttonPrevEl = qs(sliderComponent, '[swiper="prev-button"]');
            const paginationEl = qs(sliderComponent, '[swiper="pagination"]');

            if (!sliderEl) return;

            sliderComponent.__swiperInstance = new window.Swiper(sliderEl, {
                slidesPerView: 3,
                spaceBetween: 16,
                direction: "horizontal",
                rewind: true,
                effect: "slide",
                pagination: paginationEl ? { el: paginationEl } : undefined,
                navigation: (buttonNextEl && buttonPrevEl) ? { nextEl: buttonNextEl, prevEl: buttonPrevEl } : undefined,
                breakpoints: {
                    768: { slidesPerView: 3, spaceBetween: 16 },
                    0: { slidesPerView: 1.1, spaceBetween: 16 },
                },
            });
        });

        // Flavors swiper
        qsa(root, '[swiper="flavors"]').forEach((sliderComponent) => {
            if (!once(sliderComponent, "swiper-flavors")) return;

            const sliderEl = qs(sliderComponent, '[swiper="slider"]');
            if (!sliderEl) return;

            sliderComponent.__swiperInstance = new window.Swiper(sliderEl, {
                slidesPerView: 3,
                spaceBetween: 16,
                direction: "horizontal",
                rewind: true,
                effect: "slide",
                breakpoints: {
                    768: { slidesPerView: 3, spaceBetween: 16 },
                    0: { slidesPerView: 1.3, spaceBetween: 16 },
                },
            });
        });

        // Ingredient swiper
        qsa(root, '[swiper="ingredient-swiper"]').forEach((sliderComponent) => {
            if (!once(sliderComponent, "swiper-ingredient")) return;

            const sliderEl = qs(sliderComponent, '[swiper="slider"]');
            const buttonNextEl = qs(sliderComponent, '[swiper="next-button"]');
            const buttonPrevEl = qs(sliderComponent, '[swiper="prev-button"]');

            if (!sliderEl) return;

            sliderComponent.__swiperInstance = new window.Swiper(sliderEl, {
                slidesPerView: 3,
                spaceBetween: 8,
                direction: "horizontal",
                centeredSlides: false,
                loop: false,
                rewind: false,
                effect: "slide",
                navigation: (buttonNextEl && buttonPrevEl) ? { nextEl: buttonNextEl, prevEl: buttonPrevEl } : undefined,
                breakpoints: {
                    768: { slidesPerView: 3, spaceBetween: 16 },
                    0: { slidesPerView: 1.2, spaceBetween: 16 },
                },
            });
        });

        // Product hero swiper (gallery)
        qsa(root, '[swiper="product-hero"]').forEach((sliderComponent) => {
            if (!once(sliderComponent, "swiper-product-hero")) return;

            const sliderEl = qs(sliderComponent, '[swiper="slider"]');
            const buttonNextEl = qs(sliderComponent, '[swiper="next-button"]');
            const buttonPrevEl = qs(sliderComponent, '[swiper="prev-button"]');
            const paginationEl = qs(sliderComponent, '[swiper="pagination"]');
            const scrollbarEl = qs(sliderComponent, '[swiper="scrollbar"]');

            if (!sliderEl) return;

            sliderComponent.__swiperInstance = new window.Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                rewind: true,
                effect: "slide",
                navigation: (buttonNextEl && buttonPrevEl) ? { nextEl: buttonNextEl, prevEl: buttonPrevEl } : undefined,
                pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
                scrollbar: scrollbarEl ? { el: scrollbarEl, draggable: true } : undefined,
            });

            // optional: thumbnails click
            const thumbs = qsa(root, ".product-gallery-thumbnail");
            if (thumbs.length) {
                thumbs.forEach((thumbEl, idx) => {
                    thumbEl.addEventListener("click", () => {
                        thumbs.forEach(t => t.classList.remove("is-current"));
                        thumbEl.classList.add("is-current");
                        sliderComponent.__swiperInstance.slideTo(idx);
                    });
                });
            }
        });
    }

    // ---------- PBAccordion (your custom one) ----------
    class PBAccordion {
        constructor(root) {
            this.root = root || document;
            this.cleanupInitialState();
            this.init();
        }

        cleanupInitialState() {
            qsa(this.root, '[pb-component="accordion"]').forEach((accordion) => {
                if (!once(accordion, "pb-accordion")) return;

                const group = qs(accordion, '[pb-accordion-element="group"]');
                if (!group) return;

                const items = qsa(group, '[pb-accordion-element="accordion"]');

                items.forEach((item) => {
                    const content = qs(item, '[pb-accordion-element="content"]');
                    const trigger = qs(item, '[pb-accordion-element="trigger"]');
                    const arrow = qs(item, '[pb-accordion-element="arrow"]');
                    const plus = qs(item, '[pb-accordion-element="plus"]');

                    if (content) {
                        content.style.maxHeight = "0";
                        content.style.opacity = "0";
                        content.style.visibility = "hidden";
                        content.style.display = "none";
                    }
                    if (trigger) trigger.setAttribute("aria-expanded", "false");
                    item.classList.remove("is-active-accordion");
                    content?.classList.remove("is-active-accordion");
                    arrow?.classList.remove("is-active-accordion");
                    plus?.classList.remove("is-active-accordion");
                });

                const initial = group.getAttribute("pb-accordion-initial");
                if (initial && initial !== "none") {
                    const initialItem = items[parseInt(initial, 10) - 1];
                    if (initialItem) this.openAccordion(initialItem);
                }
            });
        }

        init() {
            qsa(this.root, '[pb-component="accordion"]').forEach((accordion) => {
                const group = qs(accordion, '[pb-accordion-element="group"]');
                if (!group) return;

                // prevent double listener
                if (!once(group, "pb-accordion-group")) return;

                group.addEventListener("click", (e) => this.handleClick(e, group));
            });
        }

        handleClick(event, group) {
            const accordionItem = event.target.closest('[pb-accordion-element="accordion"]');
            if (!accordionItem) return;

            const isOpen = accordionItem.classList.contains("is-active-accordion");
            const isSingle = group.getAttribute("pb-accordion-single") === "true";

            if (isSingle) {
                qsa(group, '[pb-accordion-element="accordion"]').forEach((item) => {
                    if (item !== accordionItem && item.classList.contains("is-active-accordion")) {
                        this.closeAccordion(item);
                    }
                });
            }

            if (isOpen) this.closeAccordion(accordionItem);
            else this.openAccordion(accordionItem);
        }

        openAccordion(item) {
            const trigger = qs(item, '[pb-accordion-element="trigger"]');
            const content = qs(item, '[pb-accordion-element="content"]');
            const arrow = qs(item, '[pb-accordion-element="arrow"]');
            const plus = qs(item, '[pb-accordion-element="plus"]');
            if (!content || !trigger) return;

            content.style.visibility = "visible";
            content.style.display = "block";
            content.offsetHeight;

            const contentHeight = content.scrollHeight;

            requestAnimationFrame(() => {
                content.style.maxHeight = `${contentHeight}px`;
                content.style.opacity = "1";
                trigger.setAttribute("aria-expanded", "true");
                item.classList.add("is-active-accordion");
                content.classList.add("is-active-accordion");
                arrow?.classList.add("is-active-accordion");
                plus?.classList.add("is-active-accordion");
            });

            content.addEventListener("transitionend", () => {
                if (item.classList.contains("is-active-accordion")) content.style.maxHeight = "none";
            }, { once: true });
        }

        closeAccordion(item) {
            const trigger = qs(item, '[pb-accordion-element="trigger"]');
            const content = qs(item, '[pb-accordion-element="content"]');
            const arrow = qs(item, '[pb-accordion-element="arrow"]');
            const plus = qs(item, '[pb-accordion-element="plus"]');
            if (!content || !trigger) return;

            content.style.maxHeight = `${content.scrollHeight}px`;
            content.style.display = "block";
            content.offsetHeight;

            requestAnimationFrame(() => {
                content.style.maxHeight = "0";
                content.style.opacity = "0";
                trigger.setAttribute("aria-expanded", "false");
                item.classList.remove("is-active-accordion");
                content.classList.remove("is-active-accordion");
                arrow?.classList.remove("is-active-accordion");
                plus?.classList.remove("is-active-accordion");
            });

            content.addEventListener("transitionend", () => {
                if (!item.classList.contains("is-active-accordion")) {
                    content.style.visibility = "hidden";
                    content.style.display = "none";
                }
            }, { once: true });
        }
    }

    // ---------- Finsweet accordion loader (if still needed) ----------
    function initFinsweetAccordion(root) {
        // If you already have the inline loader, you can remove it from HTML and keep only this.
        const FS_URL = "https://cdn.jsdelivr.net/npm/@finsweet/attributes-accordion@1/accordion.js";
        if (document.querySelector(`script[src="${FS_URL}"]`)) return;

        // only load if component exists
        if (!qs(root, "[fs-accordion-element]")) return;

        const s = document.createElement("script");
        s.async = true;
        s.src = FS_URL;
        document.head.appendChild(s);
    }

    // --- Base URL (debug/prod) ---
    function getBaseUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("debug") === "true"
            ? "http://127.0.0.1:3000"
            : "https://cdn.alphalion.com";
    }

    function loadScript(src, { id } = {}) {
        return new Promise((resolve, reject) => {
            if (id && document.getElementById(id)) return resolve(true);

            const s = document.createElement("script");
            if (id) s.id = id;
            s.src = src;
            s.async = true;
            s.onload = () => resolve(true);
            s.onerror = () => reject(new Error(`Failed to load: ${src}`));
            document.head.appendChild(s);
        });
    }

    async function initOfferCdnLogic(mount) {
        // solo si existe el LP
        if (!mount || !mount.querySelector("#buy-box")) return;

        // evita doble carga (Shopify section reload)
        if (window.__b2o_lp01_offer_loaded) return;
        window.__b2o_lp01_offer_loaded = true;

        const src = `${getBaseUrl()}/js/offers/b2o_lp01-bfcm.js?version=9`;

        try {
            await loadScript(src, { id: "b2o-lp01-offer-cdn" });
            // si el script tiene init global, lo llamas acá:
            // window.b2o_lp01_init?.(mount);
        } catch (e) {
            console.warn("[b2o-lp01] offer CDN load failed:", e);
        }
    }

    // ---------- Main init ----------
    function init(root) {
        const mount = root?.matches?.(SELECTOR_ROOT) ? root : qs(root, SELECTOR_ROOT) || document;
        initSwipers(mount);
        new PBAccordion(mount);
        initFinsweetAccordion(mount);
        initOfferCdnLogic(mount);

        // aquí después metemos:
        // - countdown
        // - gallery thumbnails sync
        // - any Webflow interaction replacements
        // - qty/flavor logic (si aplica)
    }

    document.addEventListener("DOMContentLoaded", () => init(document));

    // Shopify theme editor re-render support
    document.addEventListener("shopify:section:load", (e) => {
        init(e.target);
    });
})();